module.exports = __webpack_public_path__ + "static/media/email.e3a82c8f.svg";